/** fileName: reduxhelper.js
 * developer: majid.garavand@gmail.com
 * created: 3/17/23
 * note: Do not delete this comment to maintain copyright rules
 * */
import {useSelector} from "react-redux";

export function SetState(keyName, data) {
    return (dispatch) => {
        dispatch({
            type: keyName,
            payload: data
        });
    }
}

export function GetState(keyName, def = null) {
    return useSelector(state => state?.[keyName] ?? def);
}